import { render, staticRenderFns } from "./ImageFormComponent.vue?vue&type=template&id=8099d7b2"
import script from "./ImageFormComponent.vue?vue&type=script&lang=js"
export * from "./ImageFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports